import { render, staticRenderFns } from "./PuzzlePreview.vue?vue&type=template&id=63d0b06d&scoped=true&"
import script from "./PuzzlePreview.vue?vue&type=script&lang=js&"
export * from "./PuzzlePreview.vue?vue&type=script&lang=js&"
import style0 from "./PuzzlePreview.vue?vue&type=style&index=0&id=63d0b06d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d0b06d",
  null
  
)

export default component.exports